<template lang="pug">
  div(class="modal-card" style="width: auto")
    header(class="modal-card-head")
      p(class="modal-card-title")
        | 絞り込み条件

    section(class="modal-card-body")
      .columns.is-multiline.is-gapless
        .column.is-half
          b-input(v-model="formProps.book_name_cont" placeholder="書籍名" id="book_name")
        .column.is-half
          b-input(v-model="formProps.book_isbn_eq" placeholder="ISBN" id="book_isbn")
        .column.is-half
          b-input(v-model="formProps.final_book_shop_name_telephone_or_and_in" placeholder="書店名・TEL(AND)" id="final_book_shop_tel")
        .column.is-half
          b-input(v-model="formProps.shop_code_cont_any" id="shop_code" placeholder="共有書店コード")
        .column.is-half
          b-input(v-model="formProps.agency_shop_code_cont_any" id="agency_shop_code" placeholder="取次書店コード")
        .column.is-half
          b-select(v-model="formProps.agency_code_eq" placeholder="帳合" expanded)
            option(value="")
            option(
                v-for="agency in agencies"
                :value="agency.code"
                :key="agency.code")
              | {{ agency.name }}
        .column.is-half
          b-select(v-model="formProps.deliver_type_id_eq" id="deliver_type" placeholder="出荷属性" expanded)
            option(value="")
            option(
                v-for="option in deliver_types"
                :value="option.id"
                :key="option.id")
              | {{ option.name }}
        .column.is-half
          b-select(v-model="formProps.sales_person_id_eq" id="sales_person" placeholder="営業担当" expanded)
            option(value="")
            option(
                v-for="option in sales_people"
                :value="option.id"
                :key="option.id")
              | {{ option.name }}
        .column.is-half
          b-input(v-model="formProps.book_ohmura_code_eq" id="ohmura_code" placeholder="大村コード")
        .column.is-half
          b-select(v-model="formProps.order_route_id_eq" id="order_route_id" placeholder="受注経路" expanded)
            option(value="")
            option(
                v-for="option in order_routes"
                :value="option.id"
                :key="option.id")
              | {{ option.name }}
        .column.is-full
          b-input(v-model="formProps.kyakutyu_memo_cont" id="kyakutyu_memo" placeholder="客注")
        .column.is-half
          b-field
            b-input(type="number" v-model="formProps.order_number_gteq" id="order_number_from" placeholder="冊数" expanded)
            p.control
              button.button ~
        .column.is-half
            b-input(type="number" v-model="formProps.order_number_lteq" id="order_number_to")
        .column.is-half
          b-field
            b-datepicker(
              placeholder="受注日"
              v-model="formProps.accepting_order_accepting_date_gteq"
              id="accepting_date_from"
              expanded
            )
            p.control
              button.button ~
        .column.is-half
          b-datepicker(
            placeholder="選択してください"
            v-model="formProps.accepting_order_accepting_date_lteq"
            id="accepting_date_to"
          )
        .column.is-half
          b-input(v-model="formProps.accepting_order_sid_in" id="sid" placeholder="受注ID")
        .column.is-half
          b-input(v-model="formProps.accepting_order_user_name_cont" id="user_name" placeholder="登録者")
        .column.is-half
          b-input(v-model="formProps.bansen_cont" id="bansen" placeholder="取次番線")
        .column.is-half
          b-input(v-model="formProps.kyakuchu_memo_bibo_shop_person_or_and_in" id="kyakutyu_memo_bibo_shop_person" placeholder="客注・備考・書店担当")
        .column.is-full
          b-field
            b-switch(v-model="formProps.only_uncompleted" id="only_uncompleted" class="switch-relative")
              | {{ onlyUncompletedText }}
    footer(class="modal-card-foot")
      button(class="button is-info is-fullwidth" @click="onSearch")
        i.fas.fa-undefine.fa-search.icon-left
        | この条件でさがす
      button(class="button" type="button" @click="$parent.close()")
        i.fas.fa-times
</template>


<script>

  export default {
    data() {
      return {
        accepting_order_items: []
      }
    },
    props: [ 'formProps' ],
    computed: {
      agencies(){ return this.$store.getters['Agencies/records'] },
      deliver_types(){ return this.$store.getters['DeliverTypes/records'] },
      sales_people() { return this.$store.getters['SalesPeople/records'] },
      order_routes() { return this.$store.getters['AcceptingOrderRoutes/records'] },
      onlyUncompletedText(){
        return this.formProps.only_uncompleted ? '未配本のみを表示する' : 'すべての注文を表示する'
      },
    },
    methods: {
      onSearch(){
        this.$emit('update:formProps', this.formProps)
        this.$emit('on-search')
        this.$parent.close()
      }
    },
    created() {
      // this.loadAsyncData()
    }
  }

</script>

<style scoped>
/* horizontalで真横に並べるため */
.modal-card-body {
  white-space: normal;
  min-width: 750px;
}
</style>